/** Shared hub constants — roles, suggestions, vendors, BBS. No DRE claims. */

export const HUB_PREFIX = "dh_hub_";

export const HUB_ROLES = ["buyer", "seller", "agent", "broker", "admin"];

export const SUGGESTION_CATEGORIES = [
  { id: "ui", label: "UI" },
  { id: "checklist", label: "Checklist" },
  { id: "messaging", label: "Messaging" },
  { id: "calendar", label: "Calendar" },
  { id: "file_packet", label: "File packet" },
  { id: "documents", label: "Documents" },
  { id: "other", label: "Other" },
];

export const SUGGESTION_STATUSES = [
  { id: "new", label: "New" },
  { id: "reviewed", label: "Reviewed" },
  { id: "accepted", label: "Accepted" },
  { id: "in_progress", label: "In progress" },
  { id: "declined", label: "Declined" },
];

export const VENDOR_GROUPS = {
  pro: [
    { id: "photographers", label: "Photographers" },
    { id: "staging", label: "Home staging" },
    { id: "renovation", label: "Home renovation" },
    { id: "cleaning_pro", label: "Home cleaning" },
    { id: "landscape_pro", label: "Landscape / yard" },
    { id: "drone", label: "Drone operators" },
    { id: "virtual_tour", label: "Virtual tour providers" },
    { id: "signs", label: "Sign installers" },
    { id: "lockbox", label: "Lockbox services" },
    { id: "escrow", label: "Escrow services" },
    { id: "title", label: "Title companies" },
    { id: "tools", label: "Office tools" },
    { id: "associations", label: "Associations" },
    { id: "templates", label: "Templates" },
    { id: "services", label: "Professional services" },
  ],
  client: [
    { id: "movers", label: "Movers" },
    { id: "cleaners", label: "Cleaners" },
    { id: "handymen", label: "Handymen" },
    { id: "painters", label: "Painters" },
    { id: "landscapers", label: "Landscapers" },
    { id: "inspectors", label: "Inspectors" },
    { id: "pest", label: "Pest control" },
    { id: "plumbers", label: "Plumbers" },
    { id: "electricians", label: "Electricians" },
    { id: "moving", label: "Moving & home prep" },
    { id: "education", label: "Buyer & seller education" },
    { id: "escrow_edu", label: "Escrow & closing basics" },
    { id: "home", label: "Home care" },
  ],
};

export const BBS_CATEGORY_IDS = [
  { id: "orgs", label: "Organizations" },
  { id: "meetings", label: "Meetings" },
  { id: "county", label: "County / state / national" },
  { id: "opens", label: "Open houses & opens" },
  { id: "training", label: "Training" },
  { id: "vendor_promos", label: "Vendor notes" },
  { id: "market", label: "Market updates" },
];

export const EVENT_SCOPES = [
  { id: "local", label: "Local" },
  { id: "regional", label: "Regional" },
  { id: "state", label: "State" },
  { id: "national", label: "National" },
];

export const EVENT_KINDS = [
  { id: "org_local", label: "Local organizations" },
  { id: "county", label: "County events" },
  { id: "state_con", label: "State conventions" },
  { id: "national_con", label: "National conventions" },
  { id: "broker_open", label: "Broker open houses" },
  { id: "agent_open", label: "Agent open houses" },
  { id: "networking", label: "Networking" },
  { id: "workshop", label: "Workshops" },
  { id: "training", label: "Training sessions" },
  { id: "vendor_expo", label: "Vendor expos" },
  { id: "expo", label: "Expo" },
  { id: "summit", label: "Summit" },
  { id: "chamber", label: "Chamber" },
  { id: "convention", label: "Convention" },
];

export const ARTICLE_SECTIONS = [
  { id: "faq", label: "FAQs" },
  { id: "features", label: "Guides" },
  { id: "tutorials", label: "Tutorials" },
  { id: "troubleshooting", label: "Troubleshooting" },
  { id: "practices", label: "Best practices" },
  { id: "links", label: "Links to both sites" },
];

export const VISIBILITY = ["public", "buyer", "seller", "agent", "broker", "pro"];

export function labelFor(list, id) {
  return list.find((item) => item.id === id)?.label || id || "";
}
